export { default as Hero } from './Hero';
export { default as About } from './About';
export { default as Payment } from './Payment';
export { default as Download } from './Download';
export { default as Features } from './Features';
export { default as Pricings } from './Pricings';
